<template>
  <div>
    <div class="row">
      <div class="col">
        <h5 class="title">Newsletter</h5>
      </div>
      <div class="col-md-auto text-right" v-if="role > 1">
        <p-button type="success" @click="newBuschtrommel()" class="mt-0" v-if="!editMode"><i
            class="bi bi-file-earmark-plus"></i> Neuer Newsletter</p-button>
        <p-button type="default" @click="editMode = false;" class="mt-0" v-if="editMode"><i class="bi bi-x-square"></i>
          Schließen</p-button>
      </div>
    </div>
    <div class="row pt-3" v-if="editMode == true">
      <div class="col">
        <div class="card mt-2 pl-3 pr-3">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-9">
                <h6 class="card-title">Newsletter erstellen/bearbeiten</h6>
              </div>
            </div>
          </div>
          <div class="card-body row">
            <div class="col">
              <mc-wysiwyg v-model="editText" :hide="editorHiddenElements"></mc-wysiwyg>
            </div>
          </div>
          <div class="row pr-3 mb-2">
            <div class="col text-right">
              <el-checkbox v-model="sendMail" label="Per E-Mail an alle Mitarbeiter senden." border
                class="mr-3"></el-checkbox>
              <p-button type="default" @click="saveDraft()" class="mt-2 mr-3"><i class="bi bi-file-earmark-plus"></i>
                Entwurf speichern</p-button>
              <p-button type="success" @click="publish()" class="mt-2"><i class="bi bi-send"></i>
                Veröffentlichen</p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col">
        <collapse>
          <div class="card mt-2 pl-3 pr-3" v-for="item in buschtrommel" :key="item.key">
            <collapse-item :title="item.title">
              <div class="row">
                <div class="col" v-html="item.text"></div>
              </div>
              <div class="row pt-3" v-if="item.status == 'Draft'">
                <div class="col text-right">
                  <p-button type="default" @click="edit(item.key, item.text)"><i class="bi bi-pencil-square"></i>
                    Bearbeiten</p-button>
                </div>
              </div>
            </collapse-item>
          </div>
        </collapse>
      </div>
    </div>
</div>
</template>
<script>
import Vue from "vue";
import { db, fc } from "../../../../firebaseDb";
import { Table, TableColumn, Input, Loading, Popover, Checkbox, MessageBox } from "element-ui";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import Collapse from '../../../UIComponents/Collapse/Collapse.vue';
import CollapseItem from '../../../UIComponents/Collapse/CollapseItem.vue';
import { McWysiwyg } from '@mycure/vue-wysiwyg';
import { httpsCallable } from "firebase/functions";
import SelectLocation from '/src/components/KET/Views/Components/KETSelectLocation.vue'

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Checkbox);
Vue.use(Loading);

export default {
  components: {
    Collapse,
    CollapseItem,
    [Input.name]: Input,
    McWysiwyg,
    MessageBox,
    SelectLocation,
  },

  data() {
    return {
      buschtrommel: [],
      loading: false,
      editText: null,
      editId: null,
      editMode: false,
      sendMail: false,
      unsaved: false,
      editorHiddenElements: {
        heading: true,
        table: true,
        strikethrough: true,
      },
      location: store.getters.userlocation,
      role: store.getters.userrole,
    };
  },
  created() {
    this.loadData()
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadData();
      }
    );
  },
  beforeRouteLeave(to, from, next) {
    if (this.unsaved) {
      MessageBox.confirm(
        "Es gibt nicht gespeicherte Änderungen. Alle Änderungen gehen verloren. Seite wirklich verlassen?",
        "Warnung",
        {
          confirmButtonText: "Verlassen",
          cancelButtonText: "Abbrechen",
          type: "warning",
          callback: (action) => {
            if (action == "confirm") {
              next()
            } else {
              next(false)
            }
          },
        }
      );
    } else {
      next()
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
  },
  methods: {
    loadData() {
      moment.locale("de");
      const buschtrommelRef = db.collection("buschtrommel");
      buschtrommelRef.where('locationID', 'array-contains', this.location).orderBy("createdAt", "desc").onSnapshot((snapshotChange) => {
        this.buschtrommel = [];
        snapshotChange.forEach((doc) => {
          var title = ""
          if (doc.data().status == "Draft") {
            title = "ENTWURF - " + moment(new Date(doc.data().createdAt.seconds * 1000))
              .format("DD. MMMM yyyy")
              .toString()
          } else if (doc.data().status == "Published") {
            title = "Newsletter - " + moment(new Date(doc.data().publishedAt.seconds * 1000))
              .format("DD. MMMM yyyy")
              .toString()
          }
          if (doc.data().status == "Published" || (doc.data().status == "Draft" && this.role > 1)) {
            this.buschtrommel.push({
              key: doc.id,
              createdAt: doc.data().createdAt,
              publishedAt: doc.data().publishedAt,
              title: title,
              text: doc.data().text,
              status: doc.data().status,
              email: doc.data().sendMail,
            });
          }

        });
        this.loading = false
      });
    },
    saveDraft() {
      if (this.editId != null) {
        db.collection("buschtrommel").doc(this.editId)
          .update({
            text: this.editText,
            status: 'Draft',
          })
          .then((docRef) => {
            this.unsaved = false;
            this.editId = docRef.id
            this.$notify({
              message: 'Entwurf wurde erfolgreich gespeichert!',
              icon: 'fa fa-check-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success',
              showClose: true,
              timeout: 5000
            })
          })
          .catch(() => {
            console.log("Saving draft failed");
          });
      } else {
        db.collection("buschtrommel")
          .add({
            text: this.editText,
            status: 'Draft',
            createdAt: new Date(),
            locationID: [this.location]
          })
          .then((docRef) => {
            this.unsaved = false;
            this.editId = docRef.id
            this.$notify({
              message: 'Entwurf wurde erfolgreich gespeichert!',
              icon: 'fa fa-check-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success',
              showClose: true,
              timeout: 5000
            })
          })
          .catch(() => {
            console.log("Saving draft failed");
          });
      }
    },
    publish() {
      if (this.editId != null) {
        db.collection("buschtrommel").doc(this.editId)
          .update({
            text: this.editText,
            publishedAt: new Date(),
            status: 'Published',
            sendMail: this.sendMail
          })
          .then(() => {
            if (this.sendMail == true) {
              console.log("Send mail")
              var sendBuschtrommel = httpsCallable(fc, "buschtrommel-sendMail");
              sendBuschtrommel({
                buschtrommelId: this.editId,
                loc: this.location
              })
            }
            this.unsaved = false;
            this.editId = null;
            this.editMode = false;
            this.$notify({
              message: 'Newsletter wurde erfolgreich veröffentlicht!',
              icon: 'fa fa-check-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success',
              showClose: true,
              timeout: 5000
            })
          })
          .catch((err) => {
            console.log("Publishing failed " + err);
          });
      } else {
        db.collection("buschtrommel")
          .add({
            text: this.editText,
            status: 'Published',
            createdAt: new Date(),
            publishedAt: new Date(),
            locationID: [this.location],
            sendMail: this.sendMail
          })
          .then((docRef) => {
            if (this.sendMail == true) {
              var sendBuschtrommel = httpsCallable(fc, "buschtrommel-sendMail");
              sendBuschtrommel({
                buschtrommelId: docRef.Id,
                loc: this.location
              })
            }
            this.unsaved = false;
            this.editId = null;
            this.editMode = false;
            this.$notify({
              message: 'Newsletter wurde erfolgreich veröffentlicht!',
              icon: 'fa fa-check-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success',
              showClose: true,
              timeout: 5000
            })
          })
          .catch(() => {
            console.log("Publishing failed");
          });
      }

    },
    edit(id, text) {
      this.editText = text
      this.editId = id
      this.editMode = true;
      this.unsaved = true;
    },
    newBuschtrommel() {
      this.editId = null;
      this.editText = null;
      this.editMode = true;
      this.unsaved = true;
    },
    preventNav(event) {
      if (!this.unsaved) return
      event.preventDefault()
      event.returnValue = ""
    },
    updateLocation(loc) {
      this.location = loc
      this.loadData()
    }
  },
};
</script>
<style>
.el-table .cell {
  word-break: break-word !important;
}

.wysiwyg-button {
  border: none !important;
}</style>
